import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { Producto } from '../../../_models/producto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { PerfilRiesgo } from '../../../_models/perfil-riesgo';
import { Nivel } from '../../../_models/nivel';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { PerfilRiesgoService } from '../../../_services/perfil-riesgo.service';
import { NivelesService } from '../../../_services/niveles.service';
import { forkJoin } from 'rxjs';
import { ProductoGarantia } from '../../../_models/producto-garantia';
import { ProductoGarantiaService } from '../../../_services/producto-garantia.service';
import {ListaItem} from '../../../_models/lista-item';
import {ListaService} from '../../../_services/lista.service';
import {ProductoService} from '../../../_services/producto.service';

@Component( {
  selector: 'app-producto-garantia',
  templateUrl: 'producto-garantia.component.html'
} )

export class ProductoGarantiaComponent implements OnInit {
  @Input() producto: Producto;
  @Output() setearValoresProducto:  EventEmitter<any> = new EventEmitter();
  carInformacionInicial = true;
  lisProductosGarantias: ProductoGarantia[] = [];
  formulario: FormGroup;
  submitted = false;
  submittedGarantia = false;
  guardando = false;
  guardandoGarantia = false;
  columnas: any[];
  ranIncorrecto = false;
  lisPerfiles: SelectItem[] = [];
  lisNivelAprueba: SelectItem[] = [];
  lisNivelExcepcion: SelectItem[] = [];
  lisPerfilesTodos: PerfilRiesgo[] = [];
  lisNivelesTodos: Nivel[] = [];
  proIgual = false;
  lisTiposValoresTodos: ListaItem[] = [];
  lisTiposValores: SelectItem[] = [];
  formularioGarantia: FormGroup;
  constructor( private proGarantiaServicio: ProductoGarantiaService,
               private navServicio: NavService,
               private location: Location,
               private fb: FormBuilder,
               private perRiesgoServicio: PerfilRiesgoService,
               private nivServicio: NivelesService,
               private conServicio: ConfirmationService,
               private lista: ListaService,
               private proServicio: ProductoService) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'perfilRiesgo', header: this.navServicio.buscarMensaje( 'PRODUCTOGARANTIA.LBL_PERFIL' ), sort: false },
      { field: 'rangoMonto', header: this.navServicio.buscarMensaje( 'PRODUCTOGARANTIA.LBL_RANGOMONTO' ), sort: false },
      { field: 'minimoCodeudores', header: this.navServicio.buscarMensaje( 'PRODUCTOGARANTIA.LBL_CODEUDOR' ), sort: false },
      { field: 'nivelAprueba', header: this.navServicio.buscarMensaje( 'PRODUCTOGARANTIA.LBL_NIVELAPRUEBA' ), sort: false },
      { field: 'nivelExcepcion', header: this.navServicio.buscarMensaje( 'PRODUCTOGARANTIA.LBL_NIVELEXCEPCION' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];


    forkJoin( this.proGarantiaServicio.listadoPorProducto( this.producto.idProducto ), this.perRiesgoServicio.listadoHabilitados(), this.nivServicio.listado(),
      this.lista.getMasterDetails( 'ListasTiposValores' ) ).subscribe( ( [ lisProductosGarantias, lisPerfiles, lisNiveles, listaTipoValores ] ) => {
      lisProductosGarantias.map( ( s: ProductoGarantia ) => {
        s.rangoMonto = s.montoMinimo + ' - ' + s.montoMaximo;
        this.lisProductosGarantias.push( s );
      } );
      this.lisPerfilesTodos = lisPerfiles;
      this.lisNivelesTodos = lisNiveles.filter( x => x.indicadorAprueba );
      this.lisTiposValores = [];
      this.lisTiposValoresTodos = listaTipoValores;
      this.lisTiposValoresTodos.map( ( s: ListaItem ) => {
        this.lisTiposValores.push( { label: s.nombre, value: s.idLista } );
      } );
      this.cargarFormulario();
      this.cargarFormularioGarantia();
      this.cargarComboInicial();
      this.carInformacionInicial = false;
    } );

  }

  cargarComboInicial() {

    this.lisPerfiles = [];
    this.lisPerfilesTodos.map( ( s: PerfilRiesgo ) => {
      this.lisPerfiles.push( { label: s.nombreRiesgo, value: s.idPerfilRiesgo } );
    } );

    this.lisNivelAprueba = [];
    this.lisNivelesTodos.map( ( s: Nivel ) => {
      this.lisNivelAprueba.push( { label: s.nombre, value: s.idNivel } );
    } );
  }

  cargarNivelExcepcion( idNivelAprueba: string ) {
    this.lisNivelExcepcion = [];
    const a = this.lisNivelesTodos.find( x => x.idNivel === idNivelAprueba );
    if ( a ) {
      this.lisNivelesTodos.map( ( s: Nivel ) => {
        if ( s.codigo >= a.codigo ) {
          this.lisNivelExcepcion.push( { label: s.nombre, value: s.idNivel } );
        }
      } );
    }
    this.f.idNivelExcepcion.setValue( null );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idProductoGarantia: [ null ],
      idProducto: [ this.producto.idProducto, [ Validators.required ] ],
      idPerfilRiesgo: [ null, [ Validators.required ] ],
      idNivelAprueba: [ null, [ Validators.required ] ],
      idNivelExcepcion: [ null, [ Validators.required ] ],
      montoMinimo: [ null, [ Validators.required, Validators.maxLength( 9 ) ] ],
      montoMaximo: [ null, [ Validators.required, Validators.maxLength( 9 ) ] ],
      minimoCodeudores: [ null, [ Validators.required, Validators.maxLength( 2 ) ] ],
      indicadorHabilitado: [ true ],
      auditoriaUsuario: [ null ],
      auditoriaFecha: [ null ],
    } );
  }

  cargarFormularioGarantia() {
    this.formularioGarantia = this.fb.group( {
      idTipoValor: [ (this.producto && this.producto.idTipoValor) ? this.producto.idTipoValor : null , [ Validators.required ] ]
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  get r() {
    return this.formularioGarantia.controls;
  }

  inhabilitar( proGarantia: ProductoGarantia ) {
    if ( this.producto.indicadorHabilitado && this.lisProductosGarantias.length == 1 ) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_NOINHABILITAR' )
      } );
    } else {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'garantias',
        accept: () => {
          this.carInformacionInicial = true;
          proGarantia.indicadorHabilitado = false;
          this.proGarantiaServicio.actualizar( proGarantia ).subscribe( regActualizado => {
            const a = this.lisProductosGarantias.findIndex( x => x.idProductoGarantia === proGarantia.idProductoGarantia );
            if ( a >= 0 ) {
              this.lisProductosGarantias.splice( a, 1 );
            }
            this.carInformacionInicial = false;
          } );
        },
        reject: () => {
        }
      } );
    }

  }

  regresar() {
    this.location.back();
  }

  onSubmit() {
    this.submitted = true;
    this.validarMonto();
    if ( this.formulario.valid && !this.ranIncorrecto ) {
      this.guardando = true;
      const proGarantia = this.formulario.value;
      this.validarIgualdad( this.lisProductosGarantias, proGarantia );
      if ( !this.proIgual ) {
        this.proGarantiaServicio.crear( proGarantia ).subscribe( garantia => {
          proGarantia.idProductoGarantia = garantia.idProductoGarantia;
          const a = this.lisPerfilesTodos.find( x => x.idPerfilRiesgo === proGarantia.idPerfilRiesgo );
          if ( a ) {
            proGarantia.perfilRiesgo = a.nombreRiesgo;
          }

          const c = this.lisNivelesTodos.find( x => x.idNivel === proGarantia.idNivelAprueba );
          if ( c ) {
            proGarantia.nivelAprueba = c.nombre;
          }

          const d = this.lisNivelesTodos.find( x => x.idNivel === proGarantia.idNivelExcepcion );
          if ( d ) {
            proGarantia.nivelExcepcion = d.nombre;
          }

          proGarantia.rangoMonto = proGarantia.montoMinimo + ' - ' + proGarantia.montoMaximo;

          // this.lisProductosGarantias.push( proGarantia );
          this.lisProductosGarantias = [ ...this.lisProductosGarantias, proGarantia ];
          this.formulario.reset();
          this.f.idProducto.setValue( this.producto.idProducto );
          this.f.indicadorHabilitado.setValue( true );
          this.lisNivelExcepcion = [];
          this.submitted = false;
          this.guardando = false;
          this.navServicio.setMesage( 1 );
        }, error => {
          this.guardando = false;
          this.navServicio.setMesage( 3 );
        } );
      } else {
        this.navServicio.setMesage( 0, {
          severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'PRODUCTORENOVACION.MSG_SONIGUALES' )
        } );
        this.guardando = false;
      }


    }
  }
  onSubmitGarantia() {
    this.submittedGarantia = true;
    if ( this.formularioGarantia.valid) {
       this.guardandoGarantia = true;
        const _dataRespaldoProducto = this.formularioGarantia.getRawValue();
        this.producto.idTipoValor = _dataRespaldoProducto.idTipoValor;
      this.proServicio.actualizar( this.producto ).subscribe( producto => {
        this.producto = producto;
        this.navServicio.setMesage( 2 );
        this.setearValoresProducto.emit(this.producto);
        this.submittedGarantia = false;
        this.guardandoGarantia = false;
      }, error => {
        this.navServicio.setMesage( 3 );
        this.submittedGarantia = false;
        this.guardandoGarantia = false;
      });


    }
  }


  validarMonto() {
    const inferior = this.f.montoMinimo.value;
    const superior = this.f.montoMaximo.value;
    this.ranIncorrecto = (inferior && superior && Number(inferior) >= Number(superior)) ? true : false;
  }

  validarIgualdad( listado: ProductoGarantia[], objComparar: ProductoGarantia ) {
    const atrIguales = [ 'idPerfilRiesgo', 'idNivelAprueba', 'idNivelExcepcion', 'montoMinimo', 'montoMaximo', 'minimoCodeudores' ];
    this.proIgual = listado.find( x => atrIguales.filter( y => x[ y ] == objComparar[ y ] ).length === atrIguales.length ) ? true : false;
  }


}
